import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const DeviceContext = /*#__PURE__*/ React.createContext({
    isMobileDevice: false
});
export const useDevice = ()=>useContext(DeviceContext);
export const DeviceProvider = (param)=>{
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(DeviceContext.Provider, {
        value: value,
        children: children
    });
};
